<app-header headerText="Registro Bono VEAB"></app-header>

<mat-tab-group mat-align-tabs="center" animationDuration="0ms" dynamicHeight=true>
    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon>unarchive</mat-icon>
            Alta de <br>Colaboradores
        </ng-template>

        <div class="row p-4 ml-4" *ngIf="!employeeFile; else employeeList">

            <div class="col-sm-12 col-md-3 py-4 text-center">
                <button class="btn-block pt-3" mat-stroked-button color="primary" (click)="createTemplateFile()">
                    <img class="img-responsive center-block" src="{{ template }}" /><br>
                    <label> Descargar Plantilla </label>
                </button>
            </div>

            <div class="col-sm-12 col-md-1 text-center arrow-center">
                <i class="material-icons align-middle"> double_arrow </i>
            </div>

            <div class="col-sm-12 col-md-3 py-4 text-center div-center">
                <mat-button-toggle-group class="div-center" #group="matButtonToggleGroup" value="{{ action }}">
                    <mat-button-toggle value="add" (change)="onSelectAction($event.value)">
                        <button mat-button color="primary" style="pointer-events:none;">
                            <mat-icon>library_add</mat-icon>
                            <label class="pl-2">Alta de Colaboradores</label>
                        </button>
                    </mat-button-toggle>
                    <mat-button-toggle value="remove" (change)="onSelectAction($event.value)">
                        <button mat-button class="warn" style="pointer-events:none;">
                            <mat-icon>library_books</mat-icon>
                            <label class="pl-2">Baja de Colaboradores</label>
                        </button>
                    </mat-button-toggle>
                </mat-button-toggle-group>
                <div class="my-4 py-2">
                    <div class="example-selected-value">{{ actionDescriptions[action] }}</div>
                </div>
            </div>

            <div class="col-sm-12 col-md-1 text-center arrow-center">
                <i class="material-icons align-middle"> double_arrow </i>
            </div>

            <div class="col-sm-12 col-md-3 py-2 text-center">
                <div class="card mt-3">
                    <div class="card-content mt-3 text-center">
                        <label>Seleccionar archivo de excel. </label>
                        <div class="file-upload">
                            <label>
                                <div class="icon">
                                    <i class="material-icons">cloud_upload</i>
                                    <input #file (change)="onFileChange($event)" ng-disabled="pageWorking" class="none"
                                        type="file" multiple="false"
                                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
                                </div>
                            </label>
                        </div>
                        <hr>
                        <p class="text-center"> El archivo debe de tener todos los campos. <br>
                        </p>
                    </div>
                </div>
            </div>

        </div>

        <ng-template #employeeList>
            <div class=" m-2">

                <h5>Registros detectados en el archivo ({{ action === 'add' ? 'Alta' : 'Baja' }}):</h5>

                <table mat-table [dataSource]="loadedEmployees" class="table">

                    <ng-container matColumnDef="row">
                        <th mat-header-cell *matHeaderCellDef> Fila No. </th>
                        <td mat-cell *matCellDef="let employee"> {{ employee.index + 1 }} </td>
                    </ng-container>

                    <ng-container matColumnDef="employeeNumber">
                        <th mat-header-cell *matHeaderCellDef> Número de Empleado </th>
                        <td mat-cell *matCellDef="let employee"> {{ employee.employeeNumber }} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns; let result"></tr>
                </table>
            </div>

            <div class="row justify-content-center">
                <div class="col-5">
                    <button class="btn btn-block btn-outline-primary" (click)="executeAction()">
                        Aceptar
                    </button>
                </div>
                <div class="col-5">
                    <button class="btn btn-block btn-outline-danger" (click)="cancel()">
                        Cancelar
                    </button>
                </div>
            </div>

        </ng-template>
    </mat-tab>

    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon>how_to_reg</mat-icon>
            Consultar <br>Colaboradores
        </ng-template>

        <div class="row p-3 justify-content-center">
            <h5 class="my-3">Colaboradores registrados</h5>
        </div>

        <div class="my-5 row">
            <div class="col-md-4 offset-md-4">
                <button class="btn btn-block btn-outline-primary" (click)="downloadReport()">
                    <mat-icon>cloud_download</mat-icon><br>
                    Descargar
                </button>
            </div>
        </div>
    </mat-tab>
</mat-tab-group>